export const extractAddressFields = (addressComponents) => {
  const find = (type, key = "long_name") =>
    addressComponents.find((c) => c.types.includes(type))?.[key] ?? ""

  const streetNumber = find("street_number", "short_name")
  const route = find("route", "short_name")

  return {
    street_address:
      [streetNumber, route].filter(Boolean).join(" ") ||
      find("premise") ||
      find("neighborhood") ||
      find("sublocality_level_1") ||
      find("plus_code"),
    city:
      find("locality") ||
      find("postal_town") ||
      find("sublocality_level_1") ||
      find("sublocality") ||
      find("administrative_area_level_2"),
    state: find("administrative_area_level_1"),
    country: find("country", "short_name"),
    zip_code: find("postal_code")
  }
}
